export const mutations = {
  SET_IS_APP(state, isApp) {
    state.isApp = isApp
  },
  LOADING(state, payload) {
    state.loading = payload
  },
  LOADING_ID(state, payload) {
    state.loadingId = payload
  },
  ASSETS(state, payload) {
    state.assets = payload
  },
  FIELDS(state, payload) {
    state.fields = payload
  },
  HOTSITE_CONFIG_SNAPSHOT(state, payload) {
    state.hotsiteConfigSnapshot = payload
  },
  ALLOWED_PERSON_TYPES_SIGNUP(state, payload) {
    state.allowed_person_types_signup = payload
  },
  TERMS(state, payload) {
    state.terms = payload
  },
  POSITION(state, payload) {
    state.position = payload
  },
  ACCOUNT_ID(state, payload) {
    state.accountId = payload
  },
  USER_INFO(state, payload) {
    state.userInfo = payload
  },
  ACCESS_TOKEN(state, payload) {
    state.access_token = payload
  },
  HIDDEN_EMAIL(state, payload) {
    state.hidden_email = payload
  },
  HIDDEN_PHONE(state, payload) {
    state.hidden_phone = payload
  },
  DELETE_REQUEST(state, payload) {
    state.delete_request = payload
  },
  SET_IS_CONFIRMED(state, payload) {
    state.is_confirmed = payload
  },
  USER_EMAIL(state, payload) {
    state.user_email = payload
  },
  CONTACTS(state, payload) {
    state.contacts = payload
  },
  SMS_CHANNEL(state, payload) {
    state.smsChannel = payload
  },
  REQUEST_ID(state, payload) {
    state.request_id = payload
  },
  COOLDOWN(state, payload) {
    state.cooldown = payload
  },
  MESSAGE_SENT(state, payload) {
    state.message_sent = payload
  },
  IS_RECOVER_SMS(state, payload) {
    state.is_recover_sms = payload
  },
  PIXEL(state, payload) {
    state.facebook_pixel_id = payload
  },
  GOOGLE_ANALYTICS(state, payload) {
    state.google_analytics_id = payload
  },
  ALLOWED_COUNTRIES(state, payload) {
    state.allowed_countries = payload
  },
  UNEDITABLE_FIELDS(state, payload) {
    state.uneditable_fields = payload
  },
  SELECTED_COUNTRY(state, payload) {
    state.selectedCountry = payload
  },
  SOCIAL_MEDIA(state, payload) {
    state.socialMedia = payload
  },
  LOGIN_MENU(state, payload) {
    state.login_menu = payload
  },
  SHOW_DELETE_BUTTONS(state, payload) {
    state.show_delete_buttons = payload
  },
  SHOW_PARTIAL_DELETE_BUTTONS(state, payload) {
    state.show_partial_delete_buttons = payload
  },
  ALLOWED_MODULES(state, payload) {
    state.allowed_modules = payload
  },
  ROUTES(state, payload) {
    state.routes = payload
  },
  HOTSITE_LINKS(state, payload) {
    state.hotsiteLinks = payload
  },
  FINISH_SCREEN_WHATSAPP(state, payload) {
    state.finishScreenWhatsapp = payload
  },
  CAPTCHA_KEY(state, payload) {
    state.captcha_key = payload
  },
  APP_STORES(state, payload) {
    state.appStores = payload
  },
  SET_IS_EXTERNAL_AUTH(state, payload) {
    state.isExternalAuth = payload
  },
  SET_CAPTCHA_TOKEN(state, payload) {
    state.currentCaptchaToken = payload
  },
  SIGNUP_TAG(state, payload) {
    state.signupTag = payload
  },
  SET_WHATSAPP_TUTORIAL_STEPS(state, payload) {
    state.whatsappTutorialSteps = payload
  },
  SET_WHATSAPP_BOTS(state, payload) {
    state.whatsappBots = payload
  },
  STORE_EVENT(state, payload) {
    state.storeEvent = payload
  },
  STORE_EVENT_GUEST(state, payload) {
    state.storeEventGuest = payload
  },
  STORE_EVENT_TOKEN(state, payload) {
    state.storeEventToken = payload
  },
  STORE_EVENT_CONFIRMED(state, payload) {
    state.storeEventConfirmed = payload
  },
  STORE_EVENT_COMPANIONS(state, payload) {
    state.storeEventCompanions = payload || []
  },
  SET_WHATSAPP_BOTS_TAG(state, payload) {
    state.whatsappBotsTag = payload
  },
  SET_WHATSAPP_TUTORIAL_MODE(state, payload) {
    state.whatsappTutorialMode = payload
  },
  SET_WHATSAPP_BOTS_PENDING_REQUEST(state, { tagKey, promise }) {
    if (promise === null) {
      delete state.whatsappBotsPendingRequests[tagKey]
    } else {
      state.whatsappBotsPendingRequests[tagKey] = promise
    }
  },
  SET_WHATSAPP_BOT_INFORMATION(state, { whatsappBotId, botInfo }) {
    state.whatsappBotInformation[whatsappBotId] = botInfo
  },
  SET_WHATSAPP_BOT_INFORMATION_PENDING_REQUEST(state, { whatsappBotId, promise }) {
    if (promise === null) {
      delete state.whatsappBotInformationPendingRequests[whatsappBotId]
    } else {
      state.whatsappBotInformationPendingRequests[whatsappBotId] = promise
    }
  }
}
